import { useState } from 'react';
import { Header } from './components/Header';
import { FlexibleFooter } from './components/FlexibleFooter';
import { LoadingSpinner } from './components/LoadingSpinner';
import { ErrorMessage } from './components/ErrorMessage';
import { UseCaseSelector } from './components/UseCaseSelector';
import { PlanningMoveFlow } from './components/PlanningMoveFlow';
import { PlanningTripFlow } from './components/PlanningTripFlow';
import { MyLocationFlow } from './components/MyLocationFlow';
import { UseCase } from './types/weather';

function App() {
  const [selectedUseCase, setSelectedUseCase] = useState<UseCase | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleUseCaseSelect = (useCase: UseCase) => {
    setSelectedUseCase(useCase);
    setError(null);
  };

  const handleBack = () => {
    setSelectedUseCase(null);
    setError(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800">
      <Header />
      
      <main className="container mx-auto px-4 py-8 max-w-7xl">
        {error && (
          <div className="mb-6">
            <ErrorMessage 
              message={error}
              onRetry={() => setError(null)}
            />
          </div>
        )}

        {loading && !selectedUseCase && (
          <div className="flex justify-center items-center h-64">
            <LoadingSpinner />
          </div>
        )}

        {!selectedUseCase && (
          <UseCaseSelector onUseCaseSelect={handleUseCaseSelect} />
        )}

        {selectedUseCase === 'planning-move' && (
          <PlanningMoveFlow 
            onBack={handleBack}
            onLoading={setLoading}
            onError={setError}
          />
        )}

        {selectedUseCase === 'planning-trip' && (
          <PlanningTripFlow 
            onBack={handleBack}
            onLoading={setLoading}
            onError={setError}
          />
        )}

        {selectedUseCase === 'my-location' && (
          <MyLocationFlow 
            onBack={handleBack}
            onLoading={setLoading}
            onError={setError}
          />
        )}
      </main>

      <FlexibleFooter />
    </div>
  );
}

export default App;
